function atInitReveals() {
  var items = document.querySelectorAll('.at-reveal:not(.at-visible)');
  if (!items.length) return;
  if (!('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('at-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('at-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  items.forEach(function (el) { observer.observe(el); });
}

function atInitGaleriaProducto() {
  var wraps = document.querySelectorAll('[data-at-galeria]');
  wraps.forEach(function (wrap) {
    var main = wrap.querySelector('[data-at-galeria-principal]');
    var thumbs = wrap.querySelectorAll('[data-at-galeria-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        var alt = thumb.getAttribute('data-alt') || '';
        if (!src) return;
        main.src = src;
        main.alt = alt;
        thumbs.forEach(function (t) { t.classList.remove('at-thumb-activa'); });
        thumb.classList.add('at-thumb-activa');
      });
    });
  });
}

function atInitVariantes() {
  var forms = document.querySelectorAll('[data-at-producto-form]');
  forms.forEach(function (formWrap) {
    var dataEl = formWrap.querySelector('[data-at-variantes-json]');
    var selects = formWrap.querySelectorAll('[data-at-opcion]');
    var idInput = formWrap.querySelector('[data-at-variant-id]');
    var precioEl = formWrap.querySelector('[data-at-precio]');
    var compareEl = formWrap.querySelector('[data-at-precio-comparado]');
    var submitBtn = formWrap.querySelector('[data-at-submit]');
    if (!dataEl || !selects.length || !idInput) return;

    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    function moneda(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
    }

    function actualizar() {
      var seleccion = Array.from(selects).map(function (s) { return s.value; });
      var match = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (precioEl) precioEl.textContent = moneda(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = moneda(match.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (submitBtn) {
        if (match.available) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.getAttribute('data-texto-disponible') || submitBtn.textContent;
        } else {
          submitBtn.disabled = true;
          submitBtn.textContent = submitBtn.getAttribute('data-texto-agotado') || 'Agotado';
        }
      }
      var cuotasEl = formWrap.querySelector('[data-at-cuotas-monto]');
      var cuotasWrap = formWrap.parentElement ? formWrap.parentElement.querySelector('[data-at-cuotas]') : null;
      if (!cuotasWrap) cuotasWrap = document.querySelector('[data-at-cuotas]');
      if (cuotasWrap) {
        var n = parseInt(cuotasWrap.getAttribute('data-cuotas-n'), 10) || 3;
        var montoEl = cuotasWrap.querySelector('[data-at-cuotas-monto]');
        if (montoEl) montoEl.textContent = moneda(match.price / n);
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    actualizar();
  });
}

function atInitComoElijo() {
  var tabs = document.querySelectorAll('[data-at-elijo-tab]');
  var panels = document.querySelectorAll('[data-at-elijo-panel]');
  if (!tabs.length || !panels.length) return;
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = tab.getAttribute('data-at-elijo-tab');
      tabs.forEach(function (t) { t.classList.remove('at-tab-activa'); });
      panels.forEach(function (p) { p.classList.remove('at-panel-activo'); });
      tab.classList.add('at-tab-activa');
      var panel = document.querySelector('[data-at-elijo-panel="' + target + '"]');
      if (panel) panel.classList.add('at-panel-activo');
    });
  });
}

function atInitFaq() {
  var items = document.querySelectorAll('[data-at-faq-item]');
  items.forEach(function (item) {
    var pregunta = item.querySelector('[data-at-faq-pregunta]');
    if (!pregunta) return;
    pregunta.addEventListener('click', function () {
      var abierto = item.classList.contains('at-faq-abierta');
      items.forEach(function (i) { i.classList.remove('at-faq-abierta'); });
      if (!abierto) item.classList.add('at-faq-abierta');
    });
  });
}

function atInitCalculadoraTalles() {
  var btn = document.getElementById('at-calcular-talle-btn');
  if (!btn) return;
  var dataEl = document.getElementById('at-tabla-talles-json');
  var tabla;
  try {
    tabla = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  function buscarTalle(valor, campoMin, campoMax) {
    if (!valor) return null;
    for (var i = 0; i < tabla.length; i++) {
      var fila = tabla[i];
      if (valor >= fila[campoMin] && valor <= fila[campoMax]) return fila.nombre;
    }
    var minFila = tabla[0];
    var maxFila = tabla[tabla.length - 1];
    if (valor < minFila[campoMin]) return null;
    if (valor > maxFila[campoMax]) return 'consultanos';
    return null;
  }

  btn.addEventListener('click', function () {
    var busto = parseFloat(document.getElementById('at-medida-busto').value);
    var cadera = parseFloat(document.getElementById('at-medida-cadera').value);

    var talleArriba = buscarTalle(busto, 'busto_min', 'busto_max');
    var talleAbajo = buscarTalle(cadera, 'cadera_min', 'cadera_max');

    var caja = document.getElementById('at-talle-resultado-caja');
    var elArriba = document.getElementById('at-talle-arriba');
    var elAbajo = document.getElementById('at-talle-abajo');
    var elMensaje = document.getElementById('at-talle-mensaje');

    elArriba.textContent = talleArriba === 'consultanos' ? '?' : (talleArriba || '?');
    elAbajo.textContent = talleAbajo === 'consultanos' ? '?' : (talleAbajo || '?');

    if (!busto || !cadera) {
      elMensaje.textContent = 'Completá al menos busto y cadera para calcular tu talle.';
    } else if (talleArriba === 'consultanos' || talleAbajo === 'consultanos' || !talleArriba || !talleAbajo) {
      elMensaje.textContent = 'Tus medidas están fuera de nuestra tabla estándar — escribinos por WhatsApp y te asesoramos.';
    } else if (talleArriba !== talleAbajo) {
      elMensaje.textContent = 'Tu combinación ideal es talle ' + talleArriba + ' arriba y ' + talleAbajo + ' abajo.';
    } else {
      elMensaje.textContent = '¡Este es tu talle Real!';
    }
    caja.style.display = 'block';
    caja.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  });
}

if (!window.__atScriptsInit) {
  window.__atScriptsInit = true;
  document.addEventListener('DOMContentLoaded', function () {
    atInitReveals();
    atInitGaleriaProducto();
    atInitVariantes();
    atInitComoElijo();
    atInitFaq();
    atInitCalculadoraTalles();
  });
}
